import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const HOW_MUCH_ARTICLE_TITLE: string =
  'How Much Is a Music License for a Small Shop?'
export const HOW_MUCH_ARTICLE_TITLE_ES: string =
  '¿Cuánto cuesta una licencia de música para una pequeña tienda?'
export const HOW_MUCH_ARTICLE_TITLE_FR: string =
  'Combien coûte une licence musicale pour un petit magasin ?'
export const HOW_MUCH_ARTICLE_TITLE_KO: string =
  '소규모 상점의 음악 라이센스는 얼마입니까?'

export const HOW_MUCH_TITLE_HTML: JSX.Element = (
  <>How Much Is a Music License for a Small Shop?</>
)
export const HOW_MUCH_TITLE_HTML_ES: JSX.Element = (
  <>¿Cuánto cuesta una licencia de música para una pequeña tienda?</>
)
export const HOW_MUCH_TITLE_HTML_FR: JSX.Element = (
  <>Combien coûte une licence musicale pour un petit magasin&nbsp;?</>
)
export const HOW_MUCH_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      소규모
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      상점의
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      음악
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      라이센스는
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      얼마입니까?
    </span>
  </>
)
export const HOW_MUCH_PAGE_ID: string = 'CDDEFAE6-5064-4AF0-8605-43BDDA4F64CA'

export const HOW_MUCH_ARTICLE_ROUTE: string =
  '/articles/how-much-is-a-music-license-for-a-small-shop'
export const HOW_MUCH_ARTICLE_ROUTE_ES: string =
  '/articles/how-much-is-a-music-license-for-a-small-shop'
export const HOW_MUCH_ARTICLE_ROUTE_FR: string =
  '/articles/how-much-is-a-music-license-for-a-small-shop'
export const HOW_MUCH_ARTICLE_ROUTE_KO: string =
  '/articles/how-much-is-a-music-license-for-a-small-shop'

export const HOW_MUCH_ARTICLE_URL: string = HOST + HOW_MUCH_ARTICLE_ROUTE_ES
export const HOW_MUCH_ARTICLE_URL_ES: string =
  HOST + '/es' + HOW_MUCH_ARTICLE_ROUTE_ES
export const HOW_MUCH_ARTICLE_URL_FR: string =
  HOST + '/fr' + HOW_MUCH_ARTICLE_ROUTE_FR
export const HOW_MUCH_ARTICLE_URL_KO: string =
  HOST + '/ko' + HOW_MUCH_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'background music streaming, business background music, discount background music, save money on background music, ambient music, licensed music, music for restaurants, music for retail, music for stores, music for shops, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'transmisión de música de fondo, música de fondo para negocios, música de fondo con descuento, ahorrar dinero en música de fondo, música ambiental, música con licencia, música para restaurantes, música para tiendas minoristas, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "musique de fond en streaming, musique de fond pour entreprise, musique de fond à prix réduit, économiser de l'argent sur la musique de fond, musique d'ambiance, musique sous licence, musique pour restaurants, musique pour magasins de détail, practical stream"
export const ARTICLE_KEYWORDS_KO =
  '스트리밍 배경 음악, 비즈니스용 배경 음악, 할인된 배경 음악, 배경 음악 비용 절감, 주변 음악, 라이선스 음악, 레스토랑용 음악, 소매점용 음악, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'FBED01FB-AA06-478A-8698-C5D0ABB39373.avif'
  : HOST + '/images/FBED01FB-AA06-478A-8698-C5D0ABB39373.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'FBED01FB-AA06-478A-8698-C5D0ABB39373.jpg'
  : HOST + '/images/FBED01FB-AA06-478A-8698-C5D0ABB39373.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'F6043720-ED0C-45CC-A855-4B6E6A93922F.jpg'
  : HOST + '/images/F6043720-ED0C-45CC-A855-4B6E6A93922F.jpg'

export const HOW_MUCH_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '1A3A53C7-280C-4BB0-B520-00B9A3F3474B.png'
  : HOST + '/images/1A3A53C7-280C-4BB0-B520-00B9A3F3474B.png'

export const ARTICLE_SUMMARY: string =
  'Did you know that playing music in a commercial setting needs to be licensed? Find out how to save on premium background music for your store.'
export const ARTICLE_SUMMARY_ES: string =
  '¿Sabías que necesitas una licencia para distribuir tu música comercialmente? Descubra cómo ahorrar en música de fondo premium en la tienda.'
export const ARTICLE_SUMMARY_FR: string =
  'Saviez-vous que vous avez besoin d’une licence pour diffuser votre musique dans un cadre commercial ? Découvrez comment économiser sur la musique de fond premium dans le magasin.'
export const ARTICLE_SUMMARY_KO: string =
  '상업적인 환경에서 음악을 재생하려면 라이선스가 필요하다는 사실을 알고 계셨나요? 매장에서 프리미엄 배경 음악을 절약하는 방법을 알아보세요.'

export const HOW_MUCH_ARTICLE_PUBLISHED_STR: string = '2025-07-07'
export const HOW_MUCH_ARTICLE_CREATED_STR: string = '2025-07-07'
export const HOW_MUCH_ARTICLE_PUBLISHED: Date = new Date(
  HOW_MUCH_ARTICLE_PUBLISHED_STR
)
export const HOW_MUCH_ARTICLE_CREATED: Date = new Date(
  HOW_MUCH_ARTICLE_CREATED_STR
)
